export default "__VITE_ASSET__a00a4411__"